<template>
    <div>
        <b-table-simple small bordered>
            <thead>
                <tr>
                    <th>
                        <div class="d-flex text-muted">
                            <div class="flex-fill">
                                <i class="fa fa-arrow-down"></i>
                                Status
                            </div>
                            <div>
                                <i class="fa fa-arrow-right"></i>
                                Type
                            </div>
                        </div>
                    </th>
                    <th><em>Default</em></th>
                    <th v-for="i in types" :key="i.value" style="font-weight: 400;">
                        {{ i.text }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><strong><em>Default</em></strong></td>
                    <td>
                        <b-input type="number" :value="getValueForField(null, null)"
                            @input="daysChange($event, null, null)" :placeholder="getDefaultDaysForField(null, null)"
                            min="0" @blur="onBlur(null, null)" />
                    </td>
                    <th v-for="i in types" :key="i.value">
                        <b-input type="number" :value="getValueForField(null, i.value)"
                            @input="daysChange($event, null, i.value)"
                            :placeholder="getDefaultDaysForField(null, i.value)" min="0"
                            @blur="onBlur(null, i.value)" />
                    </th>
                </tr>
                <tr v-for="status in statuses" :key="status.value">
                    <td>{{ status.text }}</td>
                    <td>
                        <b-input type="number" :value="getValueForField(status.value, null)"
                            @input="daysChange($event, status.value, null)"
                            :placeholder="getDefaultDaysForField(status.value, null)" min="0"
                            @blur="onBlur(status.value, null)" />
                    </td>
                    <th v-for="i in types" :key="i.value">
                        <b-input type="number" :value="getValueForField(status.value, i.value)"
                            @input="daysChange($event, status.value, i.value)"
                            :placeholder="getDefaultDaysForField(status.value, i.value)" min="0"
                            @blur="onBlur(status.value, i.value)" />
                    </th>
                </tr>
            </tbody>
        </b-table-simple>
    </div>
</template>

<script>
import { PriorAuthorizationStatusCode, PriorAuthorizationType } from '@/models/PriorAuthorization';

export default {
    name: "PriorAuthNextTouchField",
    props: {
        value: {}
    },
    data() {
        return {
            PriorAuthorizationStatusCode: PriorAuthorizationStatusCode
        }
    },
    computed: {
        defaultDays() {
            return this.value.find(i => i.status === null && i.type === null)?.days ?? 1;
        },
        statuses() {
            return [
                { value: PriorAuthorizationStatusCode.Initiated, text: "Initiated" },
                { value: PriorAuthorizationStatusCode.SentToPrescriber, text: "Sent To Prescriber" },
                { value: PriorAuthorizationStatusCode.SubmittedToInsurance, text: "Submitted To Insurance" },
                { value: PriorAuthorizationStatusCode.AnticipatedApproval, text: "Anticipated Approval" }
            ];
        },
        types() {
            return [
                { value: PriorAuthorizationType.PA, text: "PA" },
                { value: PriorAuthorizationType.Appeal, text: "Appeal" },
                { value: PriorAuthorizationType.AppealLevel2, text: "Appeal Level 2" },
                { value: PriorAuthorizationType.MedicalTierException, text: "Medical Tier Exception" }
            ]
        }
    },
    methods: {
        daysChange(days, status, type) {
            const hasStatus = !this.hasNoValue(status);
            const hasType = !this.hasNoValue(type);

            const newValue = this.value.filter(item => {
                if (hasStatus && hasType) {
                    return !(item.status === status && item.type === type);
                }
                if (hasStatus) {
                    return !(item.status === status && this.hasNoValue(item.type));
                }
                if (hasType) {
                    return !(item.type === type && this.hasNoValue(item.status));
                }
                return !(this.hasNoValue(item.status) && this.hasNoValue(item.type));
            });

            const clampedDays = Math.max(0, Math.ceil(days));

            if (days && !isNaN(days)) {
                newValue.push({ status, type, days: clampedDays });
            }

            this.$emit("input", newValue);
        },
        onBlur(status, type) {
            const item = this.value.find(i => i.status === status && i.type === type);
            if (item && typeof item.days === 'number') {
                item.days = Math.max(item.days, 0);
            }
        },
        getDefaultDaysForField(status, type) {
            if (!this.hasNoValue(type)) {
                const defaultForType = this.value.find(i => i.type === type && this.hasNoValue(i.status));
                if (defaultForType) return defaultForType.days.toString();
            }
            if (!this.hasNoValue(status)) {
                const defaultForStatus = this.value.find(i => i.status === status && this.hasNoValue(i.type));
                if (defaultForStatus) return defaultForStatus.days.toString();
            }
            return this.defaultDays.toString();
        },
        getValueForField(status, type) {
            const hasStatus = !this.hasNoValue(status);
            const hasType = !this.hasNoValue(type);
            if (hasStatus && hasType) {
                return this.value.find(i => i.status === status && i.type === type)?.days;
            }
            if (hasStatus) {
                return this.value.find(i => i.status === status && this.hasNoValue(i.type))?.days;
            }
            if (hasType) {
                return this.value.find(i => i.type === type && this.hasNoValue(i.status))?.days;
            }
            return this.value.find(i => this.hasNoValue(i.status) && this.hasNoValue(i.type))?.days;
        },
        hasNoValue(value) {
            return [undefined, null].includes(value);
        }
    }
}

</script>

<style scoped lang="scss">
::v-deep(thead th),
::v-deep(td) {
    padding: 1px 7px !important;
}

::v-deep(td) {
    height: 38px !important;
}

table ::v-deep(.actions) {
    width: 50px;
}

table ::v-deep(.active) {
    width: 40px;
}
</style>
